import Flex from '@creditflowresearch/uilib/Flex';

interface ITooltipCellSizeProps {
  dealSize: string,
  trancheSize: string,
  currencyLabel: string,
  suffix?: string,
}

export const getTooltipForBondScreenerCellSize = ({
  dealSize,
  trancheSize,
  currencyLabel,
  suffix,
}: ITooltipCellSizeProps) => (
  <>
    <Flex justify="space-between" gap={ 10 }>
      <div>Deal Size</div>
      <div>{ `${ currencyLabel } ${ dealSize } M` }</div>
    </Flex>
    <Flex justify="space-between" gap={ 10 }>
      <div>Tranche Size</div>
      <div>{ `${ currencyLabel } ${ trancheSize } M` }</div>
    </Flex>
    {
      suffix && <Flex justify="space-between">{ suffix }</Flex>
    }
  </>
);
